import React from 'react';
import Logo from '../images/CBM-Logo-Sombra.png';
import Hero from '../images/contra-el-borrado-de-las-mujeres-seminario-latam.png';
import Programa from '../files/CBM-Seminario_Latinoamerica.pdf';
import PrivacyPolicy from './PrivacyPolicy';

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      formData: {
        NOMBRE: '',
        APELLIDO: '',
        PAIS: '',
        PROVINCIA: '',
        CORREO: ''
      },
      message: '',
      privacy: false
    }
    this.handleSubmit = this.handleSubmit.bind(this);
    this.sendData = this.sendData.bind(this);
    this.clearForm = this.clearForm.bind(this);
    this.togglePP = this.togglePP.bind(this);
  };

  handleSubmit(e) {
    const copyFormData = {...this.state.formData};
    copyFormData[e.target.name] = e.target.value;
    this.setState({
      formData: copyFormData
    });
  }

  clearForm() {
    const clearForm = {
      NOMBRE: '',
      APELLIDO: '',
      PAIS: '',
      PROVINCIA: '',
      CORREO: ''
    }

    this.setState({
      formData: clearForm
    });
  }

  async sendData(e) {
    e.preventDefault();
    const { NOMBRE, APELLIDO, PAIS, PROVINCIA, CORREO } = this.state.formData;
    try {
      const response = await fetch(
          "https://v1.nocodeapi.com/contrabo/google_sheets/BPSnHJNnyjEiSVgX?tabId=H1",
          {
              method: "post",
              body: JSON.stringify([[NOMBRE, APELLIDO, PAIS, PROVINCIA, CORREO]]),
              headers: {
                  "Content-Type": "application/json"
              }
          }
      );
      const json = await response.json();
      console.log("Success:", JSON.stringify(json));
      this.setState({
        message: '¡Muchas gracias por inscribirte!'
      });
    } catch (error) {
      console.error("Error:", error);
      this.setState({
        message: 'ERROR: Ha habido un error, por favor, inténtalo de nuevo.'
      });
    }
    this.clearForm();
  }

  togglePP() {
    this.setState(prevState => ({
      privacy: !prevState.privacy
    }));
  }

  render() {
    return (
      <div className="App">
        <div className="wrapper">
          <img className="hero-img" src={Hero} alt="Contra el Borrado de las Mujeres en América Latina"/>
          <section className="hero">
              <img src={Logo} alt="Logo de la Alianza Contra el Borrado de las Mujeres"/>
              <div className="hero__title">
                  <h3>Seminario web</h3>
                  <h1>El borrado de las mujeres en América Latina</h1>
              </div>
          </section>
      </div>
    <main>
        <h2 className="main__date">21 de Julio de 2020 · 20:00 CEST</h2>
        <ul className="main__panel">
            <li>
                <h3>México</h3>
                <span>Laura <br></br> Lecuona</span>
                <p>Editora, traductora, autora y divulgadora del feminismo.</p>
            </li>
            <li>
                <h3>República Dominicana</h3>
                <span>Raquel <br></br> Rosario Sánchez</span>
                <p>Doctoranda feminista del Centro de Investigación de Género y Violencia.</p>
            </li>
            <li>
                <h3>Argentina</h3>
                <span>Rosana <br></br> López Rodríguez</span>
                <p>Profesora universitaria y activista feminista.</p>
            </li>
            <li>
                <h3>Chile</h3>
                <div className="panel__two-items">
                    <div>
                        <span>Hann F.</span>
                        <p>Feminista, lesbiana y estudiante de enfermería.</p>
                    </div>
                    <div>
                        <span>Ariel P.</span>
                        <p>Feminista, lesbiana y profesora.</p>
                    </div>
                </div>
            </li>
        </ul>
        <div className="main__intro">
            <p>¿Cuáles son las consecuencias de las propuestas legislativas que abogan por la "autoidentificación" del sexo? ¿Qué consecuencias sociales, sanitarias, educativas o culturales están teniendo?</p>
            <a href="#signup"><p>¡Apúntate a nuestro seminario web!</p></a>
            <a className="button" href={Programa} target="_blank"><span>Descarga el programa</span></a>
    </div>
    </main>
    <section className="form">
        <div className="form__wrapper">
            <h2>Apúntate</h2>
            <p>Si quieres asistir a nuestro seminario web, facilítanos tus datos y, cuando se aproxime la fecha, te enviaremos un enlace para que puedas seguirlo en directo.</p>
            <form name="signup" 
                  id="signup" 
                  onSubmit={this.sendData}>
                <label>Nombre:<span>*</span></label>
                <input type="text" 
                       required 
                       name="NOMBRE"
                       id="NOMBRE"
                       value={this.state.formData.NOMBRE}
                       onChange={this.handleSubmit}/>
                <label>Apellido:<span>*</span></label>
                <input type="text" 
                       required 
                       name="APELLIDO"
                       id="APELLIDO"
                       value={this.state.formData.APELLIDO}
                       onChange={this.handleSubmit}/>
                <label>País:</label>
                <input type="text" 
                       name="PAIS"
                       id="PAIS"
                       value={this.state.formData.PAIS}
                       onChange={this.handleSubmit}/>
                <label>Provincia:</label>
                <input type="text" 
                       name="PROVINCIA"
                       id="PROVINCIA"
                       value={this.state.formData.PROVINCIA}
                       onChange={this.handleSubmit}/>
                <label>E-mail:<span>*</span></label> 
                <input type="email" 
                       required 
                       name="CORREO"
                       id="CORREO"
                       value={this.state.formData.CORREO}
                       onChange={this.handleSubmit}/>
                <input type="submit" 
                       name="submit" 
                       value="Enviar"/>
                {this.state.message}
            </form>
            <p className="form-message"></p>
        </div>
    </section>
    <footer>
        <div className="footer-wrapper">
            <img src={Logo} alt="Logo de la Alianza Contra el Borrado de las Mujeres"/>
            <div className="footer__about">
                <h3>Sobre nosotras</h3>
                <p>La <strong>Alianza Contra el Borrado de las Mujeres</strong> es una iniciativa que nace para poner de manifiesto cómo la eliminación del sexo como categoría jurídica borra a las mujeres, invisibiliza el principal elemento sobre el que se basa la desigualdad estructural que padecen, e inutiliza las medidas de acción positiva basadas en el sexo, así como todas las políticas públicas que combaten la desigualdad entre los sexos.</p>
            </div>
            <div className="footer__social">
                <h3>Síguenos en redes</h3>
                <a href="https://twitter.com/contraborrado" target="_blank" rel="noopener noreferrer"><i className="fab fa-twitter"></i></a>
                <a href="https://www.instagram.com/contra_borrado/" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a>
                <a href="https://www.facebook.com/ContraBorrado/" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook-f"></i></a>
                <a href="https://t.me/ContraBorrado" target="_blank" rel="noopener noreferrer"><i className="fab fa-telegram-plane"></i></a>
            </div>
        </div>
        <div className="privacy">
                  <p onClick={this.togglePP} className="togglepp">Política de privacidad</p>
                  {!this.state.privacy ? '' : <PrivacyPolicy togglePP={this.togglePP}/>}
                </div>
    </footer>
      </div>
    );
  };
};

export default App; 

